import React from 'react';

import { useStaticFooter } from '@src/effects/useStaticFooter';

import FooterContent from './FooterContent';
import FooterNoData from './footerNoData';

import './footer.scss';

const Footer = () => {
    const [isLoading, content] = useStaticFooter();

    if (isLoading || !content) {
        return <FooterNoData />;
    }

    return <FooterContent content={content} />;
};

export default Footer;
